export default () => ({
    defaultParam: {
        daily: {
            date_start: null,
            date_end: null
        },
        hourly: {
            datetime_start: null,
            datetime_end: null
        },
    },
});
